<div class="upload-box" ng2FileDrop [class.invalid-upload]="isUploadError" [uploader]="fileUploader" (click)="fileUploadCtrl.click()">
  <input
    title="fileUpload"
    type="file"
    ng2FileSelect
    name="fileUpload"
    #fileUploadCtrl
    [accept]="fileInputAccept"
    [uploader]="fileUploader"
    class="file-input"
  />
  <ng-content select="[content]"></ng-content>
</div>
